export default {"src":"/_next/static/media/chsb.7d6e146a.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};